export default __webpack_public_path__ + "static/media/NOTO_SANS_JP_600.aaaed242.ttf";